"use client";

import { cn } from "../../lib";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "../accordion";

export interface MarketingFaqItem {
	question: string;
	answer: string;
}

export interface MarketingFaqSectionProps {
	title: string;
	description: string;
	items: MarketingFaqItem[];
	className?: string;
}

export function MarketingFaqSection({
	title,
	description,
	items,
	className,
}: MarketingFaqSectionProps) {
	return (
		<section
			className={cn("scroll-mt-20 py-12 lg:py-16 xl:py-24", className)}
			id="faqs"
		>
			<div className="container">
				<div className="grid grid-cols-1 gap-6 md:grid-cols-[2fr_3fr] md:gap-8 lg:gap-12">
					<div>
						<h2 className="mb-2 font-medium text-xl text-foreground leading-tighter md:text-2xl lg:text-3xl xl:text-4xl">
							{title}
						</h2>
						<p className="text-foreground/60 text-sm sm:text-lg">
							{description}
						</p>
					</div>
					<Accordion
						type="single"
						collapsible
						className="w-full space-y-2"
					>
						{items.map((item, i) => (
							<AccordionItem
								key={`faq-item-${i}`}
								value={`item-${i}`}
								className="rounded-lg border bg-card px-4 shadow-none lg:px-6"
							>
								<AccordionTrigger className="text-left font-medium text-base hover:no-underline">
									{item.question}
								</AccordionTrigger>
								<AccordionContent className="text-foreground/60">
									{item.answer}
								</AccordionContent>
							</AccordionItem>
						))}
					</Accordion>
				</div>
			</div>
		</section>
	);
}
